import { render, staticRenderFns } from "./UserSettingsNotifications.vue?vue&type=template&id=093074da&"
import script from "./UserSettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./UserSettingsNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports